import { defineBoot } from '#q-app/wrappers'
import config from 'app/package.json'
import mixpanel from 'mixpanel-browser'
import useAuthStore from 'src/stores/auth'

interface Tracker {
  logIn: (id: number | string) => void
  logOut: () => void
  track: (event: string, data?: any) => void
}

export const tracker: Tracker = {
  track: (event, data) => console.info('Tracking stub: ', event, data),
  logIn: (id) => console.info('Tracking login stub: ', id),
  logOut: () => console.info('Tracking logout stub'),
}

const TOKENS = {
  prod: '5dc8ccd59fd142f7747408285ec6e81b',
  staging: '58e8ccf65042322a4c9400724a47607d'
}

export default defineBoot(({ app }) => {
  const token = process.env.QTM_ENV && process.env.QTM_ENV in TOKENS
    ? TOKENS[process.env.QTM_ENV as keyof typeof TOKENS]
    : null

  if (token) {
    mixpanel.init(token)

    tracker.track = (event, data) => {
      const properties = data || {}

      properties.mobile_version = config.version

      const authStore = useAuthStore()

      const user = authStore.user

      if (user) {
        properties.distinct_id = user.id
      }

      if (user?.company) {
        mixpanel.track_with_groups(event, properties, { company_id: properties.company_id ?? user.company.id })
      }
      else {
        mixpanel.track(event, properties)
      }
    }

    tracker.logIn = (id) => {
      mixpanel.identify(id.toString())
    }

    tracker.logOut = () => {
      mixpanel.reset()
    }
  }

  app.provide('$tracker', tracker)
})
